import { app } from "@microsoft/teams-js";

export const isInTeams = async (): Promise<boolean> => {
  try {
    await app.initialize();
    return true;
  } catch (e) {
    return false;
  }
};
